export default __webpack_public_path__ + "static/media/12.2f034996.jpg";